module.exports = __webpack_public_path__ + "img/hint-trd-code.7233df04.webp";